import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { LoginService, logout } from "@shared-angular/services/login.service";

@Injectable()
export class PortalLoginResolver {
  constructor(public loginService: LoginService, private router: Router) { }

  public async resolve(route: ActivatedRouteSnapshot) {

    const token = route.queryParamMap.get("token");
    if (!token) {
      throw new Error("no token provided as query param");
    }
    await this.loginService.loginByPortalToken(token);

    const deeplink = route.paramMap.get('deeplink');


    const user = await this.loginService.loadMyUser();

    if (user == null) {
      logout();
      return;
    }
    if (deeplink) {
      if (deeplink == "rag-admin") { 
        window.location.href = window.location.origin + "/de/rag-admin";
      } else {
        await this.router.navigate([deeplink]);
      }
    } else {
      await this.router.navigate(['/admin/bot-admin']);
    }
  }
}